import { PrimeIcons } from 'primereact/api';
import PropTypes from 'prop-types';
import React from 'react';

import ArmisLogo from '../common/components/ArmisLogo';
import { DangerButton, PrimaryButton, SuccessButton } from '../common/components/Buttons.styles';
import { useLangs } from '../common/context/LangsContext';
import * as api from './api';
import * as Styled from './LoginForm.styles';

const LINK_CONTACT = 'mailto:bizdev@armis.com';
const LINK_DOCS = 'https://docs.ic.armis.com';

const STATUS = {
    ERROR: 'ERROR',
    PENDING: 'PENDING',
    SENDING: 'SENDING',
    SENT: 'SENT',
};

function SubmitArea({ email, status }) {
    const langs = useLangs();
    if (status === STATUS.PENDING) {
        return <PrimaryButton label={langs.SEND} disabled={!email} />;
    }
    if (status === STATUS.SENDING) {
        return <PrimaryButton label={langs.SENDING} loading />;
    }
    if (status === STATUS.SENT) {
        return (
            <>
                <SuccessButton label={langs.SENT} icon={PrimeIcons.CHECK} />
                <small>{langs.RETRY}</small>
            </>
        );
    }
    if (status === STATUS.ERROR) {
        return (
            <>
                <DangerButton label={langs.ERROR} icon={PrimeIcons.EXCLAMATION_TRIANGLE} />
                <small>{langs.TRY_LATER}</small>
            </>
        );
    }
    return null;
}

SubmitArea.propTypes = {
    email: PropTypes.string.isRequired,
    status: PropTypes.oneOf(Object.values(STATUS)),
};

export default function LoginForm() {
    const langs = useLangs();
    const [email, setEmail] = React.useState('');
    const [status, setStatus] = React.useState(STATUS.PENDING);

    async function onSubmit(e) {
        e.preventDefault();
        setStatus(STATUS.SENDING);
        const response = await api.login(email);
        setStatus(response.ok ? STATUS.SENT : STATUS.ERROR);
    }

    return (
        <Styled.Wrapper onSubmit={onSubmit}>
            <ArmisLogo />
            <Styled.Welcome>{langs.WELCOME}</Styled.Welcome>
            <small>{langs.FILL_EMAIL}</small>
            <Styled.EmailInput
                placeholder={langs.EMAIL}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                autoFocus
            />
            <SubmitArea email={email} status={status} />
            <Styled.Footer>
                ©{new Date().getFullYear()} {langs.ALL_RIGHTS_RESERVED}
                <span>•</span>
                <a
                    href={`${LINK_CONTACT}?subject=${langs.CONTACT_LINK_HREF_SUBJECT}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {langs.CONTACT_LINK_TEXT}
                </a>
                <span>•</span>
                <a href={LINK_DOCS} target="_blank" rel="noopener noreferrer">
                    {langs.DOCUMENTATION_LINK_TEXT}
                </a>
            </Styled.Footer>
        </Styled.Wrapper>
    );
}
